import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import React from "react";

const Unauthorized = () => {
  return (
    <DashboardLayout>
      <VuiBox display="flex" flexDirection="column" justifyContent="center" height="100vh">
        <VuiBox pt={3} px={3}>
          <VuiTypography textAlign="center" variant="h4" fontWeight="regular">
            Unauthorized Access
          </VuiTypography>
        </VuiBox>
      </VuiBox>
    </DashboardLayout>
  );
};

export default Unauthorized;
